/**
 * External dependencies.
 */
import { assign } from 'lodash';

/**
 * Internal dependencies.
 */
import { getPaddingMarginCss, updateBlock, addStyleTag } from '../../extensions/custom-styles';

const styling = ( props, selector = false, attributes = false ) => {
	const { blockAdvanceOptions } = attributes ? attributes : props.attributes;
	selector = selector ? selector : `.gutenify-section-${ props.clientId }`;

	if ( 'gutenify/button' === props.name ) {
		selector = `${ selector } .gutenify-button-link`;
	}

	let css = '';

	css += getPaddingMarginCss( blockAdvanceOptions, selector );

	return css;
};

const updateBlockStyle = ( data, props ) => {
	const attrs = assign( props.attributes, data );
	const css = styling( props, false, attrs );

	const styleKey = `gutenify-block-${ props.clientId }-spacing`;

	updateBlock( data, css, props, styleKey );

	// Admin
	const adminSelector = `#block-${ props.clientId } > *`;
	const adminCss = styling( props, adminSelector );
	addStyleTag( props, adminCss, `gutenify-block-${ props.clientId }-spacing`, true );
};

export { updateBlockStyle };

export default styling;
